/* Creekside header chrome: mobile drawer, predictive search, cart proxy to Stiletto's quick cart. */
(function () {
  'use strict';
  var root;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(v) {
    var n = typeof v === 'string' ? parseFloat(v) : v / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: n % 1 ? 2 : 0 }).format(n); } catch (e) { return '$' + n; }
  }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; document.body.style.overflow = on ? 'hidden' : ''; }

  function init() {
    root = $('[data-ck-chrome]');
    if (!root || root.__ckInit) return;
    root.__ckInit = true;

    /* ---- Same-page anchors: "/#club" → "#club" when that section is on this page ---- */
    $$('a[href^="/#"]', root).forEach(function (a) {
      var id = a.getAttribute('href').slice(2);
      if (id && document.getElementById(id)) { a.setAttribute('href', '#' + id); }
    });

    /* ---- Mobile drawer ---- */
    var menu = $('[data-ck-menu-drawer]', root), lastFocus;
    function openDrawer() { lastFocus = document.activeElement; menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false'); lockScroll(true); var f = menu.querySelector('button, a'); if (f) f.focus(); }
    function closeDrawer() { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); lockScroll(false); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    $('[data-ck-open-menu]', root).addEventListener('click', openDrawer);
    menu.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeDrawer(); });

    /* ---- Mega menu: close on Escape, touch-friendly first tap ---- */
    $$('.nav-item', root).forEach(function (li) {
      var a = li.querySelector('.nav-link[aria-haspopup]');
      if (!a) return;
      a.setAttribute('aria-expanded', 'false');
      li.addEventListener('mouseenter', function () { a.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { a.setAttribute('aria-expanded', 'false'); li.classList.remove('open'); });
      a.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !li.classList.contains('open')) { e.preventDefault(); $$('.nav-item.open', root).forEach(function (o) { o.classList.remove('open'); }); li.classList.add('open'); }
      });
    });

    /* ---- Cart: open Stiletto's quick cart via its (hidden) header icon ---- */
    var cartBtn = $('[data-ck-open-cart]', root), bag = $('[data-ck-bag-count]', root);
    cartBtn.addEventListener('click', function (e) {
      var st = document.querySelector('[data-section-type="header"] [data-js-cart-icon]');
      if (st && document.querySelector('.quick-cart, [data-quick-cart], quick-cart')) { e.preventDefault(); st.click(); }
    });
    function setCount(n) {
      n = parseInt(n, 10) || 0;
      bag.textContent = n; bag.hidden = n === 0;
      cartBtn.setAttribute('aria-label', 'Open bag, ' + n + ' item' + (n === 1 ? '' : 's'));
    }
    var stCount = document.querySelector('[data-section-type="header"] [data-js-cart-count]');
    if (stCount && window.MutationObserver) {
      new MutationObserver(function () { setCount(stCount.textContent.trim()); }).observe(stCount, { childList: true, characterData: true, subtree: true });
    }
    function refreshCount() { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
    document.addEventListener('apps:product-added-to-cart', function () { setTimeout(refreshCount, 400); });
    document.addEventListener('cart:updated', refreshCount);

    /* ---- Search overlay (Shopify predictive search) ---- */
    var sov = $('[data-ck-search]', root), q = $('#ck-q', root), sres = $('[data-ck-search-res]', root), active = -1, timer, seq = 0;
    var popular = (sres.getAttribute('data-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var phone = sres.getAttribute('data-empty-phone') || '';
    function openSearch() { sov.classList.add('open'); lockScroll(true); q.value = ''; render(''); setTimeout(function () { q.focus(); }, 20); }
    function closeSearch() { sov.classList.remove('open'); lockScroll(false); }
    function renderPopular() {
      sres.innerHTML = popular.length ? '<div class="grp">Popular searches</div><div class="search-chips">' + popular.map(function (s) { return '<button type="button" class="btn btn-ghost btn-sm" data-sugg="' + esc(s) + '">' + esc(s) + '</button>'; }).join('') + '</div>' : '';
    }
    function render(term) {
      term = term.trim(); active = -1;
      if (!term) { renderPopular(); return; }
      clearTimeout(timer);
      timer = setTimeout(function () {
        var my = ++seq;
        var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          if (my !== seq) return;
          var res = (d && d.resources && d.resources.results) || {};
          var cols = (res.collections || []).filter(function (c) { return !/^podcast-ep-/.test(c.handle); }).slice(0, 3);
          var prods = res.products || [];
          var html = '';
          if (cols.length) html += '<div class="grp">Brands &amp; collections</div>' + cols.map(function (c) { return '<a class="search-hit" href="' + esc(c.url) + '"><span></span><div><b>' + esc(c.title) + '</b><small>Collection</small></div><span class="pr">→</span></a>'; }).join('');
          if (prods.length) html += '<div class="grp">Cigars</div>' + prods.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
            return '<a class="search-hit" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span></span>') +
              '<div><b>' + esc(p.title) + '</b><small>' + esc(p.vendor || '') + (p.available ? '' : ' · Sold out') + '</small></div><span class="pr mono-num">from ' + money(p.price_min || p.price) + '</span></a>';
          }).join('');
          html += '<a class="search-hit" href="/search?type=product&q=' + encodeURIComponent(term) + '"><span></span><div><b>See all results for “' + esc(term) + '”</b></div><span class="pr">↵</span></a>';
          if (!prods.length && !cols.length) html = '<div class="search-empty">Nothing in the shop matches “' + esc(term) + '”. Try a brand, wrapper or size' + (phone ? ', or <a href="tel:' + esc(phone.replace(/[^\d+]/g, '')) + '" style="text-decoration:underline">call the lounge</a>' : '') + '.</div>' + html;
          sres.innerHTML = html;
        }).catch(function () {});
      }, 140);
    }
    $$('[data-ck-open-search]', root).forEach(function (b) { b.addEventListener('click', openSearch); });
    $('[data-ck-close-search]', root).addEventListener('click', closeSearch);
    sov.addEventListener('click', function (e) {
      if (e.target === sov) closeSearch();
      var s = e.target.closest('[data-sugg]'); if (s) { q.value = s.getAttribute('data-sugg'); render(q.value); q.focus(); }
    });
    q.addEventListener('input', function () { render(q.value); });
    q.addEventListener('keydown', function (e) {
      var items = $$('.search-hit', sres);
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && items.length) {
        e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (it, i) { it.classList.toggle('active', i === active); }); items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && items[active]) { e.preventDefault(); items[active].click(); }
    });
    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (e.key === '/' && !/input|textarea|select/i.test(tag) && !document.activeElement.isContentEditable) { e.preventDefault(); openSearch(); }
      if (e.key === 'Escape') {
        if (sov.classList.contains('open')) closeSearch();
        if (menu.classList.contains('open')) closeDrawer();
        $$('.nav-item.open', root).forEach(function (o) { o.classList.remove('open'); });
        if (root.contains(document.activeElement) && document.activeElement.closest('.mega')) document.activeElement.blur();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-ck-chrome]')) init(); });
})();

/* External menu links (e.g. merch store) open in a new tab and skip Stiletto page transitions */
(function () {
  function ext() {
    document.querySelectorAll('.ck-chrome a[href^="http"]').forEach(function (a) {
      try { if (new URL(a.href).host === location.host) return; } catch (e) { return; }
      a.target = '_blank'; a.rel = 'noopener'; a.classList.add('no-transition');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ext); else ext();
})();
